import Marketing from './Marketing';
import { api } from '../../helpers/Api';
var MarketingStore = /** @class */ (function () {
    function MarketingStore() {
    }
    MarketingStore.prototype.read = function (id, main) {
        if (main) {
            return api.get('/marketings' + '?main=true');
        }
        return api.get('/marketings/' + id).then(function (values) { return new Marketing(values); });
    };
    MarketingStore.prototype.create = function (data, main) {
        if (main) {
            return api.post('marketings' + '?main=true', data).then(function (values) { return new Marketing(values); });
        }
        return api.post('/marketings', data);
    };
    MarketingStore.prototype.update = function (id, data, main) {
        if (main) {
            return api.put("/marketings/".concat(id, "?main=true"), data);
        }
        return api.put('/marketings/' + id, data);
    };
    MarketingStore.prototype.createDefault = function (data) {
        return api.post("/marketings/default", data);
    };
    return MarketingStore;
}());
export default MarketingStore;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Marketings/MarketingStore.ts
// module id = 756
// module chunks = 0